import React, { Component } from 'react';
import styled from 'styled-components';

const StyledTextArea = styled.textarea`
  width: 100%;
  background-color: white;
  font-size: 18px;
  appearance: none;

  &:disabled {
    opacity: 0.5;
    background-color: #efefef;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    border-color: white;
    box-shadow: 0px 0px 10px #45cdf4;
  }

  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 0px;

  ${props => props.error ? "border-color: red; background-color: rgba(255,0,0,0.07);" : ""};

`

class TextArea extends Component {
  render() {
    let { value } = this.props
    value = value ? value : ""
    return (
      <StyledTextArea type="text" name={this.props.name} id={this.props.name} {...this.props} value={value} />
    )
  }
}

export default TextArea